import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import LinkedIn from './pages/LinkedIn';
import NetworkScripts from './pages/NetworkScripts';
import BlogSeries from './pages/BlogSeries';
import ContentCampaigns from './pages/ContentCampaigns';
import AdminPrompts from './pages/AdminPrompts';
import FinancialPlanning from './pages/FinancialPlanning';
import CoachPage from './components/coach/CoachPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/auth" element={<Auth />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/optimize" element={<Navigate to="/coach" replace />} />
          <Route path="/results/:fitAnalysisId" element={<Navigate to="/coach" replace />} />
          <Route
            path="/linkedin"
            element={
              <ProtectedRoute>
                <LinkedIn />
              </ProtectedRoute>
            }
          />
          <Route
            path="/network-scripts"
            element={
              <ProtectedRoute>
                <NetworkScripts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog-series"
            element={
              <ProtectedRoute>
                <BlogSeries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/content-campaigns"
            element={
              <ProtectedRoute>
                <ContentCampaigns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/prompts"
            element={
              <ProtectedRoute>
                <AdminPrompts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/financial-planning"
            element={
              <ProtectedRoute>
                <FinancialPlanning />
              </ProtectedRoute>
            }
          />
          <Route path="/resume-flow" element={<Navigate to="/coach" replace />} />
          <Route
            path="/coach"
            element={
              <ProtectedRoute>
                <CoachPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
